import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const location = useLocation();
  const { t } = useTranslation();
  const lang = location.pathname.split("/")[1] === "en" ? "en" : "fa";
  const withLang = (to) => `/${lang}${to}`;

  return (
    <footer className="col-xs-12 noPadding">
      <div className="bg-blue text-white">
        <div className="container pt-5 pb-5" dir={lang === "en" ? "ltr" : "rtl"}>
          <div className="col-xs-12 col-md-4 footerimg fade-in from-bottom delay-1 visible">
            <Link aria-label={t("footer.logoAlt")} to={`/${lang}`}>
              <img alt={t("footer.logoAlt")} className="img-responsive center-block" src="/assets/flogo.png" />
            </Link>
            <ul className="socials">
              <li><a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><img alt="LinkedIn" src="/assets/linkedin.png" /></a></li>
              <li><a href="https://wa.me/989134083783" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><img alt="WhatsApp" src="/assets/whatsapp.png" /></a></li>
              <li><a href="mailto:info@aramisautomation.com" aria-label={t("footer.emailAlt")}><img alt={t("footer.emailAlt")} src="/assets/message.png" /></a></li>
            </ul>
          </div>

          <div className="col-xs-12 col-md-8 footertext fade-in from-bottom delay-2 visible">
            <div className="col-xs-12 col-md-6">
              <h3 className="mb-2">{t("footer.quickAccess")}</h3>
              <ul>
                <li><Link to={withLang("/aboutus")}>{t("nav.about")}</Link></li>
                <li><Link to={withLang("/service")}>{t("nav.service")}</Link></li>
                <li><Link to={withLang("/personel")}>{t("nav.personel")}</Link></li>
              </ul>
            </div>
            <div className="col-xs-12 col-md-6 fade-in from-bottom delay-3 visible">
              <h3 className="mb-2">{t("footer.contactWays")}</h3>
              <ul>
                <li><a href="tel:02140443116"><img alt={t("footer.phoneAlt")} src="/assets/phone.png" />021-40443116</a></li>
                <li><img alt={t("footer.locationAlt")} src="/assets/location.png" /><span>{t("contact.address")}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="buttom-footer"><p>{t("footer.copyright")}</p></div>
      </div>
    </footer>
  );
}
